import React from 'react'

import { Navbar, Footer } from '../../../components';
import PremiumArticle from './PremiumArticle';

export default function Premarticle14() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <PremiumArticle article="article14" headerImage="solarcells.jpg" photographer=" Valentin J-W from Pixabay" />
        <Footer />
    </div>
  )
}
